import { CommandNames } from 'utils/constants/swarm/swarm-command-names';
import RidGenerator from 'utils/swarm/rid-generator';
import { EachWayPartnerTermsResponse } from 'interfaces/sportsbook-data-levels';
import { WebsocketEnhanced } from 'interfaces/spring-websocket-interfaces';
import { connectingWS } from 'hooks/useSpringConnect';
import Store from 'store';
import { setEachWayPartnerTerms } from 'store/actions';

export const getEachWay = (params: { market_id?: number }): void => {
  connectingWS.then((socket: WebsocketEnhanced) => {
    socket.sendCommand(
      {
        command: CommandNames.GET_EACH_WAY_PARTNER_TERMS,
        params,
        rid: RidGenerator.gForCommand()
      },
      '',
      (data: EachWayPartnerTermsResponse) => {
        if (data?.details && params.market_id) {
          Store.dispatch(
            setEachWayPartnerTerms(data.details, params.market_id)
          );
        }
      }
    );
  });
};
